module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "online-users"
    }
  }, [_c('ul', {
    attrs: {
      "id": "online-users-list"
    }
  }, _vm._l((_vm.onlineUserList), function(user) {
    return (user.id) ? _c('li', [(_vm.isLoggedIn) ? [(_vm.loggedUser.id !== user.id) ? _c('span', {
      staticClass: "message-user",
      on: {
        "click": function($event) {
          _vm.openConversation(user)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-comment-alt"
    }), _vm._v(" Chat\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loggedUser.id === user.id) ? _c('span', {
      staticClass: "self-user-message-space"
    }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "alias"
    }, [_c('router-link', {
      attrs: {
        "to": ("/Developer/" + (user.stringUrl))
      }
    }, [_c('i', {
      staticClass: "fas fa-user"
    }), _vm._v(" " + _vm._s(user.alias))])], 1)], 2) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55e04efe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/OnlineUsers/OnlineUsers.vue
// module id = 873
// module chunks = 2